
import React from 'react';
import PropTypes from 'prop-types';

function Header({ title }) {
  return (
    <header className="bg-gradient-to-r from-teal-50 via-cyan-50 to-teal-50 shadow-sm py-4 mb-4">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <h1 className="text-lg sm:text-2xl font-semibold text-slate-800">{title || 'Curso de Biología'}</h1>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  title: PropTypes.string
};

export default Header;
